import React, { Component } from 'react'
import Included from '../Included'
import DarkThemeNav from '../common/dark-theme-nav';

class Search extends Component {

  constructor(props) {
    super(props)
  }

  render (){
    return(
      <section><a className="anchor"id="search"></a>
        <h2>Search</h2>
        <p>The search component should be used to present a consistent search experience utilising a free text box and search button.</p>
        <DarkThemeNav anchor="search" />
        <div className="search js-search" role="search">
          <div className="search-input">
            <input type="text" placeholder="Search" />
            <i className="fa fa-search"></i>
          </div>
          <button className="nav__action-btn search-toggle"><i className="fa fa-search"></i></button>
        </div>

        <button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
    <pre className="hide-code"><code className="language-html">{`<div class="search js-search" role="search">
  <div class="search-input">
    <input type="text" placeholder="Search" />
    <i class="fa fa-search"></i>
  </div>
  <button class="nav__action-btn search-toggle"><i class="fa fa-search"></i></button>
</div>`}</code></pre>

        <br/>
        <p>The search component text box will be hidden on load by default. You can force it open on load by passing the following variable when initializing the component:</p>
        <pre><code className="language-js">{`commonUI.initializeSearch({openOnLoad: true})`}</code></pre>
        <br/>
        <p>The search component text box visibility will be toggled when the search icon is clicked. To force it to always stay open you can pass the following variable when initializing the component:</p>
        <pre><code className="language-js">{`commonUI.initializeSearch({allowClose: false })`}</code></pre>
        <br/>
        <p>The search components fires some events which you can hook into to execute your search within your application.</p>
        <pre><code className="language-js">{`commonUI.initializeSearch({selector: "#mySearch"});

var mySearch = document.getElementById("mySearch");

mySearch.addEventListener('open.commonui.search', function(){
  console.log('open search')
});

mySearch.addEventListener('close.commonui.search', function(){
  console.log('close search')
});

mySearch.addEventListener('do.commonui.search', function(){
  console.log('do search');
});`}
        </code></pre>

        <br/><br/>

        <h3>Search within Navigation Component</h3>

        <p>The search component has some unique behaviours when placed inside a navigation component. When clicking the search action icon in responsive mode (sm an md) the search box will be fixed under the nav component.</p>

        <select className="size-select">
          <option value="auto">Select a resolution</option>
          <option value="482">480px (xs)</option>
          <option value="770">768px (sm)</option>
          <option value="994">992px (md)</option>
          <option value="1202">1200px (lg)</option>
          <option value="1602">1600px (xlg)</option>
        </select>
        <br/><br/>
        <div className="iframe-container" style={{"height":"110px"}}>
          <iframe seamless srcDoc={`
          <html>
            <head>
              <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/all.css">
              <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/v4-shims.css"> 
              <link rel="stylesheet" type="text/css" href="https://fonts.googleapis.com/css?family=Roboto">
              <link rel="stylesheet" type="text/css" href="css/commonUI.css">
              <link rel="stylesheet" type="text/css" href="css/styleguide.css">
              <script language="javascript" src="js/commonUI.js"></script>
            </head>
            <body>

              <nav class="nav">
                <div class="nav__inner">
                  <div class="nav__header">
                    <a class="nav__logo nav__logo--small" href="/" title="CME Group"></a>
                    <h1 class="nav__app-name">CORE</h1>
                  </div>
                  <ul class="nav__items--primary">
                    <li class="nav__item--primary"><a>Home</a></li>
                    <li class="nav__item--primary"><a>Margin Calculator</a></li>
                    <li class="nav__item--primary"><a>Reports</a></li>
                    <li class="nav__item--primary"><a>Download Center</a></li>
                  </ul>
                  <ul class="nav__actions">
                    <li class="nav__action">
                      <div class="search js-search" role="search" id="mySearch">
                        <div class="search-input">
                          <input type="text" placeholder="Search" class="text-input" />
                          <i class="fa fa-search"></i>
                        </div>
                        <button class="nav__action-btn search-toggle"><i class="fa fa-search"></i></button>
                      </div>
                    </li>
                    <li class="nav__action"><button class="nav__action-btn"><i class="fa fa-user"></i></button></li>
                    <li class="nav__action"><button class="nav__action-btn"><i class="fa fa-bell"></i></button></li>
                  </ul>
                </div>
              </nav>
              <script language="javascript">
                commonUI.initializeSearch({ selector: "#mySearch", openOnLoad: false, allowClose: true, alwaysOpenDownInNav: false  });

                var mySearch = document.getElementById("mySearch");

                mySearch.addEventListener('open.commonui.search', function(){
                    console.log('open search')
                });

                mySearch.addEventListener('close.commonui.search', function(){
                    console.log('close search')
                });

                mySearch.addEventListener('do.commonui.search', function(){
                  console.log('do search');
                });

               </script>
            </body>
          </html>
        `}></iframe>
        </div>

        <button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
        <pre className="hide-code"><code className="language-html">{`<nav class="nav">
  <div class="nav__inner">
    <div class="nav__header">
      <a class="nav__logo nav__logo--small" href="/" title="CME Group"></a>
      <h1 class="nav__app-name">CORE</h1>
    </div>
    <ul class="nav__items--primary">
      <li class="nav__item--primary"><a>Home</a></li>
      <li class="nav__item--primary"><a>Margin Calculator</a></li>
      <li class="nav__item--primary"><a>Reports</a></li>
      <li class="nav__item--primary"><a>Download Center</a></li>
    </ul>
    <ul class="nav__actions">
      <li class="nav__action">
        <div class="search js-search" role="search" id="mySearch">
          <div class="search-input">
            <input type="text" placeholder="Search" class="text-input" />
            <i class="fa fa-search"></i>
          </div>
          <button class="nav__action-btn search-toggle"><i class="fa fa-search"></i></button>
        </div>
      </li>
      <li class="nav__action"><button class="nav__action-btn"><i class="fa fa-user"></i></button></li>
      <li class="nav__action"><button class="nav__action-btn"><i class="fa fa-bell"></i></button></li>
    </ul>
  </div>
</nav>
<script language="javascript">
  commonUI.initializeSearch({ selector: "#mySearch", openOnLoad: false, allowClose: true, alwaysOpenDownInNav: false  });

  var mySearch = document.getElementById("mySearch");

  mySearch.addEventListener('open.commonui.search', function(){
      console.log('open search')
  });

  mySearch.addEventListener('close.commonui.search', function(){
      console.log('close search')
  });

  mySearch.addEventListener('do.commonui.search', function(){
    console.log('do search');
  });

 </script>`}</code></pre>

        <br/>

        <p>The search component can be forced for all responsive variants to always open underneath the navigation component by passing the following variable when initializing the component:</p>
        <pre><code className="language-js">{`commonUI.initializeSearch({alwaysOpenDownInNav: true})`}</code></pre>
        <br/>

        <br/>
        <hr/>
      </section>
    )
  }
}
export default Search



// WEBPACK FOOTER //
// ./styleguide/components/sections/Search.js